export { default as NextPureIconBadgeLinkHelper } from './NextPureIconBadgeLinkHelper';
